const util = {};

util.noop = function noop() {
  return false;
};
util.isPathActive = function isPathActive(route) {
  var matched = route.matched;

  for (var m in matched) {
    var match = matched[m];

    if (this.content == match.path) {
      return true;
    }
  }

  return false;
};
util.isMatch = function isMatch(route, rules) {
  var matched = route.matched;
  var params = route.params;
  var query = route.query;

  for (var m in matched) {
    var match = matched[m];

    for (var r in rules) {
      var rule = rules[r];

      if (rule.path == match.path) {
        var right = true;
        if (rule.params) {
          for (var p in rule.params) {
            if (params[p] != rule.params[p]) {
              right = false;
            }
          }
        }
        if (rule.query) {
          for (var q in rule.query) {
            if (query[q] != rule.query[q]) {
              right = false;
            }
          }
        }
      }

      if (right) {
        return true;
      }
    }
  }

  return false;
};
util.isMetaActive = function isPathActive(route) {
  var matched = route.matched;

  for (var m in matched) {
    var match = matched[m];

    if (this.menu == match.meta.menu) {
      return true;
    }
  }

  return false;
};
export default util;
